import { NavigateFunction } from 'react-router-dom'

import { getUrlWithParams } from 'core-components/helpers/url'
import { userApi } from 'core/classes/services/api/UserApi'

interface IRegistrationRedirectArgs {
  redirectRequestId?: number | null
  email: string
  allowRedirect?: boolean
  navigate: NavigateFunction
}

export const registrationRedirect = async ({
  redirectRequestId,
  navigate,
  email,
  allowRedirect,
}: IRegistrationRedirectArgs) => {
  const isSignSuccess = await userApi.signInGuest(email)
  if (isSignSuccess) {
    if (redirectRequestId && allowRedirect) {
      navigate(getUrlWithParams({ rid: redirectRequestId }))
    }
    window.location.reload()
  }
}
